<template>
  <v-card
    elevation="0"
    style="width: 840px; margin-right: 140px;"
  >
    <v-card-title class="affiliate-title">
      {{ $t('affiliateProgram.affiliateProgram') }}
    </v-card-title>
    <v-card-text>
      <v-alert class="affiliate-alert">
        <div>
          <div class="affiliate-alert-affiliate-condition-text">
            {{ $t('affiliateProgram.affiliateCondition') }}
            <v-img
              :src="starEyesEmoji"
              width="24"
              height="24"
            />
          </div>
          <a
            :href="redirectToAffiliateProgram"
            target="_blank"
            class="affiliate-alert-affiliate-link"
          >
            {{ $t('affiliateProgram.affiliateMoreAboutProgram') }}
          </a>
        </div>
        <div
          class="affiliate-contact-support-list"
          v-html="$t('affiliateProgram.affiliateSupport')"
        ></div>
      </v-alert>

      <!--  AFFILIATE LINKS  -->
      <div v-if="profile.team && profile.team.isOwner">
        <affiliate-creating-links-list />
        <affiliate-link-generating :profile="profile" />
        <affiliate-statistics-and-payments-tabs />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import AffiliateCreatingLinksList from '@/components/affiliate/AffiliateCreatingLinksList.vue'
import AffiliateLinkGenerating from '@/components/affiliate/AffiliateLinkGenerating.vue'
import AffiliateStatisticsAndPaymentsTabs from '@/components/affiliate/AffiliateStatisticsAndPaymentsTabs.vue'
import starEyesEmoji from '@/assets/starEyesEmoji.svg'

export default {
  name: 'Affiliate',
  components: {
    AffiliateStatisticsAndPaymentsTabs,
    AffiliateLinkGenerating,
    AffiliateCreatingLinksList,
  },
  data: () => ({
    starEyesEmoji
  }),
  computed: {
    ...mapGetters({
      profile: 'main/profile',
    }),

    redirectToAffiliateProgram() {
      const { locale } = this.$i18n
      const landingUrl = process.env.VUE_APP_BASE_LANDING_URL
      const path = ['en', 'cn'].includes(locale)  ? 'affiliate-program' : `${locale}/affiliate-program`

      return `${landingUrl}${path}`
    }
  },
  created() {
    this.$store.dispatch('main/loadProfile')
  },
}
</script>

<style>
.affiliate-contact-support-list {
  color: var(--v-text-primary-base);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.affiliate-contact-support-list li {
  margin-top: 2px;
}

.affiliate-title {
  padding-top: 0;
  height: 52px;
  color: var(--v-text-primary-base);
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0;
}

.affiliate-alert,
.affiliate-alert.v-alert:not(.v-sheet--tile) {
  display: flex;
  width: 830px;
  padding: 30px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  border-radius: 24px;
  margin-bottom: 32px;
  background-image: url("~@/assets/affiliateAlertBackground.svg");
}

.affiliate-alert-affiliate-condition-text {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 6px;
  color: var(--v-text-primary-base);
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  margin-bottom: 4px;
}

.affiliate-alert-affiliate-link {
  text-decoration: unset;
  border-bottom: 1px solid var(--v-link-primary-border-default-base);
  color: var(--v-link-primary-text-default-base);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.affiliate-alert .v-alert__content {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
